import script from "./ClientInfoRefererTooltip.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientInfoRefererTooltip.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__